import React from 'react';
import {
  Button
} from "@material-ui/core";
import Tooltip from '@material-ui/core/Tooltip';




const ExportButtonsManyWithExcel = ({ ...props }) => {

    const PrintAndExel = (PrintPDFExcelExport) => {


        props.PrintPDFExcelExportFunction(PrintPDFExcelExport);
        //console.log(PrintPDFExcelExport);
       // console.log(props);
        //PrintPDFExcelExportFunction("Print");
        
      };

  return (
    
    <>
                  <Tooltip  title="Print">
                  <Button
                      variant="contained"
                      color="primary"
                      className="mr-2 sw_icons"
                      onClick={() => PrintAndExel("print")}
                    >
                      <i class="fas fa-print"></i>
                    </Button>
                   
                  
                  </Tooltip>
                  
                  <Tooltip  title="Export to Excel">
                  <Button
                    variant="contained"
                    color="primary"
                    className="mr-2 sw_icons"
                    onClick={() => PrintAndExel("excel")}
                  >
                    <i className="far fa-file-excel"></i>
                  </Button>
                  
                  </Tooltip>
    </>
  );
};

export default ExportButtonsManyWithExcel;
